import { array, func, string } from 'prop-types'
import { Asset } from '@opallabs/cassini'
import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { AnalyticsConsumer } from '@opallabs/quanta'

const checkIcon = () =>
  renderIcon('checkmark', {
    style: { height: 14, width: 14, color: 'white' },
    ariaMode: 'hidden',
  })

const handleClick = (asset, selectedAssetId, setSelectedAssetId, track) => {
  if (selectedAssetId !== asset.id) {
    track('click', { value: 'Change Asset' })
  }
  setSelectedAssetId(asset.id)
}

const NoAssetsMessage = () => (
  <div className={kuiperClassNames('no-images')}>
    <div className={kuiperClassNames('text')}>
      There are no images associated with this moment
    </div>
  </div>
)

const ImageViewer = ({
  assets,
  className,
  selectedAssetId,
  setSelectedAssetId,
}) => {
  if (!assets || assets.length === 0) return <NoAssetsMessage />

  return (
    <div className={kuiperClassNames(className)}>
      <AnalyticsConsumer>
        {({ track }) =>
          assets.map((asset, idx) => (
            <div className={kuiperClassNames('image-wrapper')} key={idx}>
              <Asset
                alt={asset.filename}
                assetReference={asset}
                className={kuiperClassNames('image', {
                  selected: selectedAssetId === asset.id,
                })}
                onClick={() =>
                  handleClick(asset, selectedAssetId, setSelectedAssetId, track)
                }
                preview={true}
              />
              {selectedAssetId === asset.id ? checkIcon() : null}
            </div>
          ))
        }
      </AnalyticsConsumer>
    </div>
  )
}

ImageViewer.propTypes = {
  assets: array,
  className: string,
  selectedAssetId: string,
  setSelectedAssetId: func,
}

export default ImageViewer
